var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('modale-form',{ref:"form",attrs:{"titolo":_vm.titoloModale,"campi":_vm.campi,"config":_vm.config},on:{"close":_vm.annulla}})}
var staticRenderFns = []

export { render, staticRenderFns }